// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"409":"7c5a6588","418":"633bb7c2","694":"3e273b73","813":"0744a5d8"}[chunkId] + ".chunk.css";
};